interface DurationSliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

export default function DurationSlider({ 
  value, 
  onChange,
  min = 1,
  max = 30
}: DurationSliderProps) {
  return (
    <div className="max-w-xs">
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
      />
      <div className="mt-2 flex justify-between text-xs text-gray-500">
        <span>{min} day</span>
        <span>{max} days</span>
      </div>
    </div>
  );
}